import { render, staticRenderFns } from "./feedBack.vue?vue&type=template&id=5683a7dd&scoped=true&"
import script from "./feedBack.vue?vue&type=script&lang=js&"
export * from "./feedBack.vue?vue&type=script&lang=js&"
import style0 from "./feedBack.vue?vue&type=style&index=0&id=5683a7dd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5683a7dd",
  null
  
)

export default component.exports